module.exports = __webpack_public_path__ + "static/media/french_quarter_kitchen_banner.8bec4641.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/french_quarter_kitchen_banner.JPG
// module id = 249
// module chunks = 0